export default __webpack_public_path__ + "svgs/logo-9ce834a7.svg";